unable to read source [project]/src/persist-plugins/local-storage.ts